export default __webpack_public_path__ + "static/media/w_f_2022_a.0b977891.jpeg";